import React from 'react';

const LocaleContext = React.createContext()

export const LocaleProvider = ({ children }) => {
    const [locale, setLocale] = React.useState('en')
    // React.useEffect(() => localStorage.setItem('locale', locale), [locale])
    return (
        <LocaleContext.Provider value={[locale, setLocale]}>{children}</LocaleContext.Provider>
    )
}

export const useLocaleContext = () => React.useContext(LocaleContext);